import React from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import Ellipsis from '@wix/da-ds/pkg/Icons/Ellipsis';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import UserIdentityLargeMobile from '../../../../../User/IdentityLargeMobile';
import ThumbActions from '../../../../Helper/ThumbActions';
import { useOverlayContext } from '../../../../hooks/useOverlayContext';
import TopInfoBarWatchButton from './TopInfoBarWatchButton';
import s from './TopInfoBar.scss';
var TopInfoBar = function (_a) {
    var deviation = _a.deviation, extraActions = _a.extraActions, className = _a.className;
    var isWatchButtonFlagEnabled = useFlag('browsev2_mobile_thumbs_watch_button');
    var showAuthorWatchButton = useOverlayContext(deviation).showAuthorWatchButton;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement("div", { className: s['left'] },
            React.createElement(UserIdentityLargeMobile, { user: deviation.author, deviation: deviation, className: s['author'] })),
        React.createElement("div", { className: s['right'] },
            showAuthorWatchButton && isWatchButtonFlagEnabled && (React.createElement(TopInfoBarWatchButton, { deviation: deviation })),
            extraActions && (React.createElement(ThumbActions, { className: s['actions'], actions: extraActions, deviation: deviation },
                React.createElement(Ellipsis, { size: IconSize.MEDIUM, disableDefaultColors: true }))))));
};
TopInfoBar.displayName = 'TopInfoBar';
export default TopInfoBar;
//# sourceMappingURL=TopInfoBar.js.map